import { FC } from 'react';
import { Card } from '@mui/material';

import { ShsTextInput, ShsCheckboxGroup, ShsRadioButtonGroup } from 'src/components/common';
import { TeachersList } from 'src/constants/centers/form';
import { required } from 'react-admin';
import { Theme } from 'src/Theme';
import { SUBJECT_TYPE } from 'src/constants';

export const SpecialServiceInputsCard: FC = () => {
    return (
        <Card sx={{ width: '100%', marginBottom: 2, padding: 2 }}>
            <ShsTextInput source={'name'} label="Назва послуги" validate={required()} />
            <ShsRadioButtonGroup
                row={false}
                sx={{ color: Theme.palette.primary.midnightBlue, display: 'none' }}
                source={'subject_type'}
                defaultValue={SUBJECT_TYPE.SPECIAL}
                choices={[{ id: SUBJECT_TYPE.SPECIAL, name: 'Спеціальна послуга' }]}
                required
            />
            <ShsCheckboxGroup
                source={'roles'}
                label="Спеціальний викладач"
                choices={TeachersList}
                validate={required('Щоб зберегти послугу виберіть хоча б одного спеціального викладача')}
            />
        </Card>
    );
};
